import {
  compact,
  find,
  isEmpty,
  get,
  first,
} from 'lodash';

function formatPhoneNumber(phoneNumbers) {
  const firstOrPrimary = compact([
    find(phoneNumbers, { is_primary: true }),
    first(phoneNumbers),
  ]);
  if (isEmpty(firstOrPrimary)) {
    return '';
  }
  const number = get(firstOrPrimary, '[0].phone_number', '');
  const city = number.slice(0, 3);
  const formattedNumber = `${number.slice(3, 6)} - ${number.slice(6, 10)}`;
  const ex = number.slice(10) ? `ex: ${number.slice(10)}` : '';

  return `(${city}) ${formattedNumber} ${ex}`.trim();
}

export default formatPhoneNumber;



// WEBPACK FOOTER //
// ./public/js/utils/formatPhoneNumber.js